import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io";

export default function BehaviorStatic(props) {
   const { data, setValue, value } = props;
   const currentSection = data?.testState?.currentSection;
   return (
      <div className="behavior-static">
         <div className="title">
            <span className="label">{data?.title}:</span>
            <span className="value">{data?.description}</span>
         </div>
         <div className="options">
            {data?.options.map((option, index) => (
               <div className={`option ${value===option.id ? "selected" : ""}`} 
                  key={index} 
                  onClick={() => setValue(data.id, option.id)}>
                  <span className="title">
                     <span className="icon">
                        <IoMdRadioButtonOff className="off"/>
                        <IoMdRadioButtonOn className="on"/>
                     </span>
                     <span className="name">{option.name}</span>
                  </span>
                  <span className="description">{option.description}</span>
               </div>
            ))}
         </div>
      </div >
   );
}
